export default __webpack_public_path__ + "static/media/hero.ed50d922.png";